import React, { useEffect } from 'react';

import { Divider, Grid } from 'core/components/library';

import { Text, Button, Select, Switch, Tabs, Documents } from 'core/components';

import * as icons from 'core/icons';

import Detalles from './Tabs/Detalles';
import * as enums from '../../../../core/enums';

const Detalle = props => {
    const { values, editing, handleChange } = props;

    return (
        <form autoComplete='off' noValidate>
            <Grid container spacing={1}>
                <Grid item>
                    <Text
                        //type='partida'
                        required={true}
                        fullWidth
                        name='id'
                        label='Partida'
                        value={values.id}
                        onChange={handleChange}
                        editing={editing}
                    />
                </Grid>
                <Grid item>
                    <Text
                        type={'0.2'}
                        required={true}
                        fullWidth
                        name='epigrafe'
                        label='Epigrafe'
                        value={values.epigrafe}
                        onChange={handleChange}
                        editing={editing}
                    />
                </Grid>
                <Grid item>
                    <Select
                        fullWidth
                        editing={editing}
                        label='Tipo'
                        name='tipo'
                        options={enums.tipoPartida}
                        value={values.tipo}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs>
                    <Text
                        fullWidth
                        name='descripcion'
                        label='Decricpción'
                        value={values.descripcion}
                        onChange={handleChange}
                        editing={editing}
                    />
                </Grid>
            </Grid>
            <Tabs
                tabs={[
                    {
                        label: 'Detalles',
                        icon: icons.DetailIcon,
                        component: <Detalles {...props} />
                    }
                ]}
            />
        </form>
    );
};

export default Detalle;
